// src/layouts/AuthGuard.js
import React, { useEffect } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useState } from "react";
import { styled } from "@mui/material/styles";
import { jwtDecode } from "jwt-decode";
import Navbar from "./navbar";
import Footer from "./footer";
import Page from "components/Page";
import NavDrawer from "layouts/drawernav";

const RootStyle = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
});

const MainStyle = styled("div")(() => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingTop: 64,
}));

export default function AuthGuard(role = 1) {
  const [open, setOpen] = useState(false);
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");

  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);

  useEffect(() => {
    if (token) {
      const decodedToken = jwtDecode(token);
      console.log("Decoded Token:", decodedToken);
      console.log("role:", role);
    }
  }, [token]);

  if (!token || !userId) {
    return <Navigate to="/admin/login" replace />;
  }

  const decodedToken = jwtDecode(token);
  const hasCorrectRole = decodedToken.role === role.role;

  if (!hasCorrectRole) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <RootStyle>
      <MainStyle>
        <Navbar handleDrawerOpen={handleDrawerOpen} />
        <NavDrawer openNav={open} handleDrawerClose={handleDrawerClose} />
        <Page>
          <Outlet />
        </Page>
        <Footer />
      </MainStyle>
    </RootStyle>
  );
}
